module.exports = __webpack_public_path__ + "static/media/country_gt.708bdfc4.webp";